module.exports = __webpack_public_path__ + "img/انتزاعی.8c5dda10.png";